import service from "@/utils/request";

// 审批规则列表
export const approvalRuleListApi = () => {
  return service({
    url: "/api/v1/approval/rule/list",
    method: "get",
  });
};

// 审批规则编辑
export interface approvalRuleEditData {
  mode: number;
  type: number;
  condition: number;
  condition_item_list: {
    item_key: string;
    item_value: string;
    status: number;
  }[];
  staff_ids: number[];
  copy_staff_ids?: number[];
  confirm_staff_ids?: number[];
}
export const approvalRuleEditApi = (data: approvalRuleEditData) => {
  return service({
    url: "/api/v1/approval/rule/edit",
    method: "post",
    data,
  });
};

// 审批规则编辑状态
export interface approvalRuleStatusEditData {
  type: number;
  status: number;
}
export const approvalRuleStatusEditApi = (data: approvalRuleStatusEditData) => {
  return service({
    url: "/api/v1/approval/rule/edit_status",
    method: "post",
    data,
  });
};

// 审批列表
export interface approvalListData {
  page?: number;
  page_size?: number;
  sort_field?: string;
  sort_type?: string;
  approval_no?: string;
  start_date?: string;
  end_date?: string;
  student_id?: number;
  handle_status?: number;
  type?: number;
  initiate_staff_id?: number;
  approval_staff_id?: number;
  copy_staff_id?: number;
  status?: number;
  status_arr?: number[];
}
export const approvalListApi = (data: approvalListData) => {
  return service({
    url: "/api/v1/approval/order/list",
    method: "post",
    data,
  });
};

// 审批记录上一个和下一个
export interface approvalAdjoinData {
  approval_id: number;
  sort_field?: string;
  sort_type?: string;
  approval_no?: string;
  start_date?: string;
  end_date?: string;
  student_id?: number;
  handle_status?: number;
  type?: number;
  initiate_staff_id?: number;
  approval_staff_id?: number;
  copy_staff_id?: number;
  status?: number;
  status_arr?: number[];
}
export const approvalAdjoinApi = (params: approvalAdjoinData) => {
  return service({
    url: "/api/v1/approval/order/last_and_next",
    method: "get",
    params,
  });
};

// 审批详情
export interface approvalDetailData {
  approval_id?: string;
}
export const approvalDetailApi = (params: approvalDetailData) => {
  return service({
    url: "/api/v1/approval/order/detail",
    method: "get",
    params,
  });
};

// 审批通过
export interface approvalPassData {
  approval_id: number;
  remark: string;
}
export const approvalPassApi = (data: approvalPassData) => {
  return service({
    url: "/api/v1/approval/order/pass",
    method: "post",
    data,
  });
};

// 审批拒绝
export interface approvalRejectData {
  approval_id: number;
  remark: string;
}
export const approvalRejectApi = (data: approvalRejectData) => {
  return service({
    url: "/api/v1/approval/order/reject",
    method: "post",
    data,
  });
};

// 待我审批的订单数量
export const approvalWaitTotalApi = () => {
  return service({
    url: "/api/v1/approval/order/my_count",
    method: "get",
  });
};
